import { render, staticRenderFns } from "./IpsAlert.vue?vue&type=template&id=08f06baa&scoped=true"
import script from "./IpsAlert.vue?vue&type=script&lang=js"
export * from "./IpsAlert.vue?vue&type=script&lang=js"
import style0 from "./IpsAlert.vue?vue&type=style&index=0&id=08f06baa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08f06baa",
  null
  
)

export default component.exports